import translator from '@Components/Utilities/Translator';
import { useState, useRef } from 'react';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
import Box from '@mui/material/Box';
import Popper from '@mui/material/Popper';
import Button from '@mui/material/Button';
import { useRecoilValue } from 'recoil';
import { sandhillsRequest, gtmPushEvent } from '@Components/Utilities/SandhillsUtility';
import atoms from '@Components/Utilities/SandhillsAtoms';
import CircularProgress from '@mui/material/CircularProgress';
import { gtmEventType } from '@Components/Utilities/SandhillsConstants';

const CompareCheckbox = loadable(() => import('@Components/Compare/CompareCheckbox'));

const OptionsPopper = (props) => {
    const routes = useRecoilValue(atoms.routes);
    const [anchorEl, setAnchorEl] = useState(null);
    const [options, setOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const popperRef = useRef(null);

    const handleClick = (event) => {
        gtmPushEvent(gtmEventType.optionsButtonClick, 'options-listingID', props.Id);
        setAnchorEl(anchorEl ? null : event.currentTarget);
        if (!anchorEl) {
            setIsLoading(true);
            popperOptions();
        }
    };

    const open = Boolean(anchorEl);
    const id = open ? ('options-popper-' + props.Id) : undefined;

    //retrieve the popper options
    const popperOptions = () => {
        sandhillsRequest({
            url: routes.GetOptionsPopper,
            method: 'post',
            data: {
                ownerCRMID: props.ownerCRMID.toString(),
                externalID: props.externalID, 
                baseCatID: props.baseCatID 
            },
            errorHandling: {
                showDetails: true,
                useConsole: true,
                useAlert: false
            }
        }).then((response) => {
            if (response) {
                setOptions(response);
                setIsLoading(false);
            } else {
                setIsLoading(false);
            }
        });
    }

    //if option in popper is clicked, close the popper
    const handleOptionClick = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <div className="options-popper-div">
                <Button onClick={handleClick} className='options-popper-btn'
                    variant="text"
                    style={{
                    padding: props.IsDetailPage ? '4px 5px' : '0',
                    fontSize: props.IsDetailPage ? '13px' : '11px',
                    marginTop: props.IsDetailPage ? '5px' : '0'
                    }}>
                    <i className='fa-solid fa-gear'></i>
                    <strong>{translator.translate('sandhills.crm.dscrm.options')}</strong>
                </Button>
                <Popper
                    id={id}
                    popperRef={popperRef}
                    placement="bottom-end"
                    disablePortal={true}
                    modifiers={[
                        {
                            name: 'flip',
                            enabled: false,
                            options: {
                                altBoundary: false,
                                rootBoundary: 'document',
                                padding: 8,
                            },
                        },
                        {
                            name: 'preventOverflow',
                            enabled: false,
                            options: {
                                altAxis: false,
                                altBoundary: false,
                                tether: false,
                                rootBoundary: 'document',
                                padding: 8,
                            },
                        },
                    ]}
                    open={open}
                    anchorEl={anchorEl}
                    sx={{
                        zIndex: 1001, 
                        backgroundColor: 'white',
                        borderRadius: '5px',
                        'box-shadow': '0px 5px 15px 0px rgba(0, 0, 0, 0.1)'
                    } }
                >
                    <Box sx={{
                        width: '205px', backgroundColor: 'white', borderRadius: '5px',
                        'box-shadow': '0px 5px 15px 0px rgba(0, 0, 0, 0.1)', padding: '5px', color: 'black',
                    alignContent: 'center', alignItems: 'center'
                    }}>
                        {isLoading ?
                            <div style={{ width: '100%', height: '100%', textAlign: 'center', alignItems: 'center', alignContent: 'center' }}>
                                <CircularProgress sx={{ height: '30px', width: '30px' }} /></div> :
                            <>
                        <CompareCheckbox
                                    UpdateCompareListing={props.UpdateCompareListing}
                                    IsCheckedForCompare={props.IsCheckedForCompare}
                                    IsDisabled={props.IsDisabled}
                                    CompareUrl={props.CompareUrl}
                                    classNames={props.classNames}
                                    Id={props.Id}
                                    ShowCompare={props.ShowCompare}
                                    ShowCompareURL={props.ShowCompareURL}

                        />
                        {options?.map((option, index) => {
                            return (
                                <a className='options-popper-item' key={option.DisplayText + index} href={option.URL} target={'_blank'} onClick={handleOptionClick}>
                                    <div>
                                        <img src={option.ImageURL} alt={option.ImageAltText} style={{
                                            width: '16px',
                                            marginRight: '6px'
                                        }} />
                                        <strong><span>{option.DisplayText}</span></strong>
                                            <span className='visually-hidden'> ({translator.translate('sandhills.opensinanewtab')})</span>
                                    </div>  
                                </a>                           
                            )
                        })}
                        </>}
                    </Box>                 
                </Popper>
            </div> 
        </>
    );
};

export default OptionsPopper;